/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';

import { mapToCssModules, tagPropType } from './utils';

const propTypes = {
  tag: tagPropType,
  noGutters: PropTypes.bool,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  form: PropTypes.bool,
  smallGutters: PropTypes.bool
};

const defaultProps = {
  tag: 'div',
  noGutters: false,
  className: '',
  cssModule: {},
  form: false,
  smallGutters: false
};

const Row = props => {
  const {
    className,
    cssModule,
    noGutters,
    smallGutters,
    tag: Tag,
    form,
    ...attributes
  } = props;

  const classes = mapToCssModules(
    classNames(
      className,
      noGutters ? 'no-gutters' : null,
      smallGutters ? 'small-gutters' : null,
      form ? 'form-row' : 'row'
    ),
    cssModule
  );

  return <Tag {...attributes} className={classes} />;
};

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;

export default styled(Row)``;
